import React, { Component } from 'react'
import { Divider,Button, Box } from 'rebass'
import styled from 'styled-components'
import Container from '../../elements/Container'
import Title from '../../elements/Text/Title'
import Para from '../../elements/Text/Para'
import { colors, fonts,fontSizes } from '../../theme'
import Pulse from 'react-reveal/Pulse';

const TextSeparator = styled(Divider)`
  width: 30px;
  height: 5px;
  background-color: ${colors.secondary};
  border-bottom: none;
  border-radius: 15px;
  margin-bottom: 2rem;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
`
const Links = styled(Button)`
  color: ${colors.secondary};
  background-color: transparent;
  font-family: ${fonts.primary};
  font-weight: 700;
  font-size: ${fontSizes[2] + 'px'};
  text-decoration: none;
  cursor: pointer;
`

class About extends Component{
  
state = {
  read: 0,
}
handleread = no => {
  this.setState({
    read: no,
  })
}
  render(){
    return(

  <Container id="about" bg={colors.primary}>
    <Title color={colors.white}>
      We help you to grow your business
    </Title>
    <TextSeparator />
    {this.state.read !==1 ?
   <Box><Pulse effect="fadeInUp"> <Para fontSize={fontSizes[4]+'px'}>
      JAIN S N & Co. is a leading firm of Chartered Accountants established in
      2012. Led by eminent and highly experienced partners and complemented by a
      team of multi disciplinary professionals, we offer a diverse range of
      professional services to our clients, besides our core competencies of
      audit and taxation.
    </Para></Pulse>
    <Links onClick={() => this.handleread(1)}>
    {' '}
     More
  </Links>
</Box>
    :<div><Para>
    JAIN S N & Co. is a leading firm of Chartered Accountants established in
    2012. Led by eminent and highly experienced partners and complemented by a
    team of multi disciplinary professionals, we offer a diverse range of
    professional services to our clients, besides our core competencies of
    audit and taxation.
  </Para>
    <Para>
      With over 6 YEARS of experience, we have been providing advice and support
      to both domestic and international clients in diverse sectors on audit,
      accounting, taxation and regulatory matters.
    </Para>
    <Para>
      Built on a strong commitment to client service, the Firm acts as a
      One-Stop Advisor offering expertise and hands-on support. We pride
      ourselves on our quality and integrity to drive the growth of our clients.
    </Para>
    <Links onClick={() => this.handleread(0)}>
                              {' '}
                              Go back
                            </Links>
                            </div>
  }
  </Container>
)
}
}

export default About


// WEBPACK FOOTER //
// ./src/components/home/About.js